<template src="./confermeOrdini.html"></template>

<script>
import { get_confemeOrdini } from "@/api/api.ordini.js";
import DialogPdf from "@/components/dialog/ordini/PdfConferma.vue";

export default {
  components: {
    DialogPdf,
  },

  props: {
    role: { type: String, default: "" },
  },

  data: () => ({
    dati: [],

    headers: [
      { text: "Pdf", align: "center", value: "Tipo_Documento", sortable: true },
      { text: "Riferimento", align: "center", value: "Riferimento", sortable: true },
      { text: "Num.Ordine", align: "center", value: "Num_Ord", sortable: true },
      { text: "Data", align: "center", value: "Data_ord", sortable: true },
      { text: "DataC", align: "center", value: "DataConfermaWeb", sortable: true },
      /* { text: "Riferimento", align: "center", value: "Riferimento" }, */
      { text: "RagSoc", align: "center", value: "ClRagSoc", sortable: true },
      { text: "E-Mail inviate", align: "center", value: "MailInviate", sortable: true },
    ],

    search: "",
    pagination: {
      rowsPerPage: 250,
      sortBy: "ClRagSoc",
    },

    daConfermare: true,
    contRighe: 0,

    filtroArrayConferma: [
      { text: "Tutti", img: "" },
      { text: "Da confermare", img: "create", color: "grey" },
      { text: "Confermati", img: "check_circle", color: "green" },
      { text: "Data consegna da aggiornare", img: "lock", color: "red" },
    ],
    filtroConferma: "Tutti",

    prog: 0,
    codCliente: "",
    confermato: false,
    fuoriTempo: false,
    numOrd: "",
    rif: "",
    dialog: false,

    page: 1,
    pageCount: 0,
    itemsPerPage: 999,

    sortBy: 'Riferimento',
    sortDesc: false,

  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];

      try {
        let par = "";
        let userSwitch = this.$store.getters["user/getUserSwitch"];
        if (userSwitch.Codice) par += userSwitch.Tipo + "/" + userSwitch.Codice;

        let res = await get_confemeOrdini(par);
        this.dati = res.data;

        this.contRighe = this.dati.length;
      } catch (error) {
        console.log(error);
      }
    },

    apriPdf(item) {
      this.prog = item.Progressivo;
      this.codCliente = item.Cod_cli;
      this.confermato = item.ConfermaWeb;
      this.numOrd = item.Num_Ord;
      this.rif = item.Riferimento;
      this.fuoriTempo = item.FuoriTempo;
      this.dialog = true;
    },

    chiudiPdf(aggiorna) {
      this.dialog = false;

      if (aggiorna) this.caricaDati();
    },

    /* changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    */

    changeSort(column) {
      if (column != 'Pdf')
        // Se la colonna cliccata è già quella di ordinamento, cambia la direzione
        if (this.sortBy === column) {
          this.sortDesc = !this.sortDesc;
        } else {
          // Altrimenti, imposta la colonna di ordinamento e la direzione ascendente
          this.sortBy = column;
          this.sortDesc = false;
        }
    },


    getImgPdf(row, tipo) {
      if (row.ConfermaWeb) {
        if (tipo == "img") return "check_circle";
        else if (tipo === "color") return "green";
      } else if (row.FuoriTempo) {
        if (tipo == "img") return "lock";
        else if (tipo == "color") return "red";
      } else {
        if (tipo == "img") return "create";
        else if (tipo == "color") return "grey";
      }
    },

    getTooltip(item) {
      if (item.FuoriTempo) return "Data consegna da aggiornare";
      else if (item.ConfermaWeb) return "Confermato";
      else return "Da confermare";
    },

    getInvio(valore) {
      return this.$i2kFunctions.replaceAll(valore, "|", "<br>");
    },

    formattaData(data) {
      return this.$i2kFunctions.formatISODateTime(data);
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    this.caricaDati();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    getDati() {
      let f = this.dati;

      if (this.filtroConferma) {
        if (this.filtroConferma == "Da confermare")
          f = f.filter((f) => f.ConfermaWeb == false && f.FuoriTempo == false);
        else if (this.filtroConferma == "Confermati")
          f = f.filter((f) => f.ConfermaWeb == true);
        else if (this.filtroConferma == "Data consegna da aggiornare")
          f = f.filter((f) => f.FuoriTempo == true);
      }

      if (this.search) {
        f = f.filter(
          (f) =>
            f.MailInviate.toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            f.Riferimento.toLowerCase().includes(this.search.toLowerCase()) ||
            f.ClRagSoc.toLowerCase().includes(this.search.toLowerCase()) ||
            f.Num_Ord.toLowerCase().includes(this.search.toLowerCase())
        );
      }

      return f;
    },
  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>

<style scoped>
table.v-table thead th {
  color: #fff;
  font-size: 14px;
}

table.v-table thead tr {
  background: #00994b;
  border-bottom: 0px !important;
}

/* table.v-table tbody tr:last-child {
  border-bottom: 1px solid #d9d9d9;
} */

table.v-table th:nth-child(1) {
  border-radius: 7px 0px 0px 7px;
}

table.v-table th:nth-last-child(1) {
  border-radius: 0px 7px 7px 0px;
}

/* table.v-table tbody td:not(:last-child) {
  border-right: 1px solid lightgray;
} */

.stileCol {
  border-left: 1px solid black;
  min-width: 13vh;
}
</style>